import { useTranslation } from "react-i18next";
import { LicenseSession, MakerLicense } from "../../Licenses.types";

import {
  Dialog,
  useSnackbarContext,
} from "@inductiveautomation/ws-components";
import { handleResponse } from "../../../../utilities/api_response";

const InvalidateSession = ({
  session,
  license,
  onClose,
  onSubmit,
}: {
  session: LicenseSession | undefined;
  license: MakerLicense;
  onClose: () => void;
  onSubmit: () => void;
}) => {
  // const { useInvalidateSessionMutation } = useApiProvider();
  // const [invalidateSession] = useInvalidateSessionMutation();

  const { addSnackbar } = useSnackbarContext();
  const { t } = useTranslation();

  return (
    <Dialog
      testId="maker-license-session-invalidate"
      isOpen={!!session}
      onClose={onClose}
      showCloseButton
      headline={t("maker_license.tabs.sessions.actions.invalidate.heading")}
      supportingText={t(
        "maker_license.tabs.sessions.actions.invalidate.description",
        {
          licenseNumber: license.key,
        }
      )}
      actions={[
        {
          label: t("common.cancel"),
          type: "cancel",
        },
        {
          label: t(
            "maker_license.tabs.sessions.actions.invalidate.submit_label"
          ),
          type: "submit",
          onClick: () => {
            addSnackbar("Placeholder for invalidate session action", {
              type: "warning",
            });
            onSubmit();

            // TODO(API): Implement when endpoint is available.
            handleResponse; // eslint-disable-line @typescript-eslint/no-unused-expressions
            // invalidateSession({ licenseId: license.id })
            //   .then((response) => {
            //     handleResponse(response, {
            //       onSuccess: () => {
            //         addSnackbar(
            //           t(
            //             "maker_license.tabs.sessions.actions.invalidate.success_message",
            //           ),
            //         );
            //         onSubmit();
            //       },
            //       onError: (message) => {
            //         addSnackbar(
            //           message ??
            //             t(
            //               "maker_license.tabs.sessions.actions.invalidate.error_message",
            //             ),
            //           { type: "error" },
            //         );
            //         onClose();
            //       },
            //     });
            //   })
            //   .catch(() => {
            //     addSnackbar(
            //       t(
            //         "maker_license.tabs.sessions.actions.invalidate.error_message",
            //       ),
            //       { type: "error" },
            //     );
            //     onClose();
            //   });
          },
        },
      ]}
    />
  );
};

export default InvalidateSession;
